


export const customer = {
    CUSTOMER : {
      BROKER : 2 ,
      SHIPPER : 3
    },
    CUSTOMER_PAN_TYPE : {
    INDIVIDUAL : 1,
    COMPANY : 2
    },
    CUSTOMERS_TYPE: {
        1: "Transporter",
        2: "Broker",
        3: "Shipper",
        4: "Enterprise",
        5: "Agri",
    },
    CUSTOMER_CHANNEL_ID: {
      APP: 1,
      PART_TIME: 20
    },
    CUSTOMER_SALES_PART_TIME_FUNCTION_ID: 119,
    CUSTOMER_STATUS: {
      REVERIFICATION: 4,
      BLACKLISTED: 6,
      REGISTERED: 2,
      REJECTED: 7,
      IN_ACTIVE: 5
    },
    CUSTOMER_LEAD_ACTION_TYPE: {
      SAVE: 'save',
      SUBMIT_KYC: 'submit_kyc',
      EDIT_MAIL: 'edit',
      MANUALLY_APPROVE: 'approval',
      REJECT_TO_LEAD: 'reject_to_lead'
    },
    CUSTOMER_FILTER_TYPES:  {
      SALES_EMPLOYEES: 'sales_employees',
      CHANNELS: 'channels',
      TYPES: 'types',
      STATUS: 'status'
    },
    HOUSE_BANK_ID: {
      ICICI_INCOMING: 37,
      ICICI_VIRTUAL: 38,
      KOTAK_VIRTUAL: 44
    }
}
